//production
export const serverUrl = "https://sbana.azurewebsites.net/api/sbservice"

//dev
// export const serverUrl = "https://sbanadev.azurewebsites.net/api/sbservice"